import React from "react";
import Refs from '../../components/Refs/Refs';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
 
export default function Home() {
  return <div>
        <Header/>
        <Refs/>
        <Footer/>
      </div>
}
